import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { useForm } from "react-hook-form";
import { selectSedes } from "../../../Sedes/services/sedes-service";
import { crearOEditarSubArea } from "../../services/subareas-service";
import { selectAreas } from "../../../../core/services/areas-service";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormSubArea = ({ modalState, onSave }) => {
    const { subArea } = modalState.data;
    const [areas, setAreas] = useState([]);
    const [sedes, setSedes] = useState([]);

    useEffect(async () => {
        const resp = await selectSedes({ status: 1 });
        if (!resp.status) return toast.error(resp.message);
        setSedes(resp.data);
    }, []);

    useEffect(async () => {
        const resp = await selectAreas();
        if (!resp.status) return toast.error(resp.message);
        setAreas(resp.data);
    }, []);

    const defaultValues = {
        id: subArea.id == null ? "" : subArea.id,
        sedes: subArea.sedes != null ? subArea.sedes : [],
        nombre: subArea.nombre != null ? subArea.nombre : "",
        descripcion: subArea.descripcion != null ? subArea.descripcion : "",
        area_id: subArea.area_id
            ? {
                  label: subArea.nombre_area,
                  value: subArea.area_id,
              }
            : "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [subArea]);

    const onCrearSubArea = async (subArea) => {
        const resp = await crearOEditarSubArea({
            ...subArea,
            area_id: subArea.area_id.value,
            sedes: subArea.sedes.map((sede) => sede.value),

        });

        if (!resp.status) return toast.error(resp.message);
        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formSubAreas"
            onSubmit={onCrearSubArea}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    type="hidden"
                    name="id"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={12}>
                    <InputController
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nombre"
                        rules={REQUIRED_RULE}
                        placeholder="Nombre del sub area"
                    />
                </Col>
                <Col sm={5}>
                    <SelectController
                        label="Area"
                        name="area_id"
                        errors={form.formState.errors}
                        control={form.control}
                        rules={REQUIRED_RULE}
                        options={areas.map((area) => {
                            return {
                                label: area.nombre,
                                value: area.id,
                            };
                        })}
                    />
                </Col>
                <Col sm={7}>
                    <SelectController
                        label="Sede"
                        name="sedes"
                        isMulti={true}
                        errors={form.formState.errors}
                        control={form.control}
                        rules={REQUIRED_RULE}
                        options={sedes.map((sede) => {
                            return {
                                label: sede.sigla,
                                value: sede.id,
                            };
                        })}
                    />
                </Col>
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        label="Descripción"
                        errors={form.formState.errors}
                        control={form.control}
                        name="descripcion"
                        rules={REQUIRED_RULE}
                        placeholder="Descripción"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormSubArea.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func,
};

export default FormSubArea;
